import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  SimpleChanges,
  OnInit,
  OnChanges,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ValidationService } from '@core/services/validation.service';

@Component({
  selector: 'app-input-field',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './input-field.component.html',
  styleUrl: './input-field.component.scss',
})
export class InputFieldComponent implements OnInit, OnChanges {
  private validationService = inject(ValidationService);

  @Input() form!: FormGroup;
  @Input() disabled: boolean = false;
  /** Alias de disabled para contextos donde el campo no puede ser habilitado por el usuario (permisos). */
  @Input() unable: boolean = false;
  @Input() required: boolean = false;
  @Input() center: boolean = false;
  @Input() labeltext!: string;
  /** Texto de ayuda opcional bajo el campo (hint). */
  @Input() infoText!: string;
  @Input() placeholder: string = '';
  /** Nombre legible del campo para los mensajes de error (ej. "Número de factura"). */
  @Input() errorFieldName!: string;
  @Input() inputControlName!: string;
  @Input() type: string = 'text';
  @Input() readonly: boolean = false;

  @Output() keydown = new EventEmitter<KeyboardEvent>();
  @Output() blur = new EventEmitter<FocusEvent>();

  onKeydown(event: KeyboardEvent) {
    this.keydown.emit(event);
  }
  onBlur(event: FocusEvent) {
    this.blur.emit(event);
  }

  ngOnInit() {
    if (this.disabled || this.unable) {
      this.control?.disable({ emitEvent: false });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['disabled'] || changes['unable']) {
      if (this.disabled || this.unable) {
        this.control?.disable({ emitEvent: false });
      } else {
        this.control?.enable({ emitEvent: false });
      }
    }
  }

  get control() {
    return this.form?.get(this.inputControlName);
  }

  get errors() {
    return this.validationService.getAllErrors(
      this.control,
      this.errorFieldName,
    );
  }
}
